export const subscribeCount = (channelDetails)=>{
    if(channelDetails?.statistics?.subscriberCount<10000){
      return(`${channelDetails?.statistics?.subscriberCount.slice(0,1)}k`);
    }
    else if(channelDetails?.statistics?.subscriberCount>10000 && channelDetails?.statistics?.subscriberCount<100000){
      return(`${channelDetails?.statistics?.subscriberCount.slice(0,2)}k`);
    }
    else if(channelDetails?.statistics?.subscriberCount>=100000 && channelDetails?.statistics?.subscriberCount<1000000){
      return(`${channelDetails?.statistics?.subscriberCount.slice(0,1)} lakh`);
    }
    else if(channelDetails?.statistics?.subscriberCount>=1000000 && channelDetails?.statistics?.subscriberCount<10000000){
      return(`${channelDetails?.statistics?.subscriberCount.slice(0,1)}M`);
    }
    else if(channelDetails?.statistics?.subscriberCount>=10000000 && channelDetails?.statistics?.subscriberCount<100000000){
      return(`${channelDetails?.statistics?.subscriberCount.slice(0,2)}M`);
    }
    else if(channelDetails?.statistics?.subscriberCount>=100000000 && channelDetails?.statistics?.subscriberCount<1000000000){
      return(`${channelDetails?.statistics?.subscriberCount.slice(0,3)}M`);
    }
    
  }